import { render, staticRenderFns } from "./HeightCalculator.vue?vue&type=template&id=634125db&"
import script from "./HeightCalculator.vue?vue&type=script&lang=ts&"
export * from "./HeightCalculator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports